import { render, staticRenderFns } from "./SpecificLocaleView.vue?vue&type=template&id=5751f455"
import script from "./SpecificLocaleView.vue?vue&type=script&lang=js"
export * from "./SpecificLocaleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports